var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mostrar)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"sk-spinner sk-spinner-three-bounce"},[_c('div',{staticClass:"sk-bounce1",style:([_vm.cor])}),_vm._v(" "),_c('div',{staticClass:"sk-bounce2",style:([_vm.cor])}),_vm._v(" "),_c('div',{staticClass:"sk-bounce3",style:([_vm.cor])})]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f478e5","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PortalLoading.vue
// module id = PA4p
// module chunks = 0